const API_BASE = (import.meta as any).env?.VITE_API_BASE_URL || '/api'

export type Obituary = {
  id: number
  name: string
  nameTamil?: string
  nameGerman?: string
  age?: number
  birthDate?: string
  deathDate?: string
  residence?: string
  residenceTamil?: string
  residenceGerman?: string
  dateOfDeath?: string
  photoUrl?: string
  origin?: string
  content?: string
  contentTamil?: string
  contentGerman?: string
  published?: boolean
  publishedBy?: string
  type?: string
  typeTamil?: string
  typeGerman?: string
  country?: string
  birthPlace?: string
  birthPlaceTamil?: string
  birthPlaceGerman?: string
  religion?: string
  tributes?: number
  hoursAgo?: number
}

export async function fetchRecentObituaries(limit = 6): Promise<Obituary[]> {
  try {
    const params = new URLSearchParams({ published: 'true', page: '0', size: String(limit), sort: 'dateOfDeath,desc' })
    let res = await fetch(`${API_BASE}/obituaries/page?${params.toString()}`)
    if (!res.ok) {
      // Fallback to simple list endpoint
      res = await fetch(`${API_BASE}/obituaries?limit=${limit}`)
    }
    if (!res.ok) {
      try { const d = await res.json(); console.warn('obituaries error:', d) } catch {}
      return []
    }
    const data = await res.json()
    return Array.isArray(data) ? data : (data?.content || [])
  } catch {
    return []
  }
}

export async function getObituary(id: number): Promise<Obituary | null> {
  const res = await fetch(`${API_BASE}/obituaries/${id}`)
  if (!res.ok) return null
  return res.json()
}

export async function createObituary(payload: Partial<Obituary>): Promise<Obituary> {
  const res = await fetch(`${API_BASE}/obituaries`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
  if (!res.ok) throw await parseProblem(res)
  return res.json()
}

export async function updateObituary(id: number, payload: Partial<Obituary>): Promise<Obituary> {
  const res = await fetch(`${API_BASE}/obituaries/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
  if (!res.ok) throw await parseProblem(res)
  return res.json()
}

export async function deleteObituary(id: number): Promise<void> {
  const res = await fetch(`${API_BASE}/obituaries/${id}`, { method: 'DELETE' })
  if (!res.ok) throw await parseProblem(res)
}

async function parseProblem(res: Response): Promise<Error> {
  try { const d:any = await res.json(); return new Error(d?.detail || d?.title || `HTTP ${res.status}`) } catch { return new Error(`HTTP ${res.status}`) }
}
